<template>
  <div
    class="tw-rounded-lg tw-overflow-hidden tw-border tw-border-light-gray-2 tw-shadow tw-transition-shadow tw-duration-300 hover:tw-shadow-xl"
  >
    <NuxtLink :to="path" :title="title">
      <div
        class="tw-full tw-flex tw-flex-col"
        :class="{ 'lg:tw-flex-row': horizontal }"
      >
        <div
          class="tw-relative tw-flex tw-flex-col"
          :class="{
            'lg:tw-w-5/12': horizontal,
            'tw-w-full': !horizontal,
          }"
        >
          <BadgeRecommended
            v-show="recommended"
            class="!tw-rounded-l-none tw-left-0"
            color="negative"
          />
          <MediaImageLazyLoad
            :src="image?.medium || ''"
            :blank-src="image?.tiny || ''"
            :alt="title"
            :ratio="2 / 1"
            seo-optimize
          />
        </div>
        <div
          :class="{
            'lg:tw-w-7/12': horizontal,
            'tw-w-full': !horizontal,
          }"
          class="tw-bg-white"
        >
          <div
            class="tw-w-full tw-p-4"
            :class="{
              'lg:tw-pl-6': horizontal,
            }"
          >
            <div
              class="tw-text-dark-gray tw-text-mb-body-small lg:tw-text-dt-body-small tw-mb-2 tw-flex tw-items-center"
            >
              <QIcon name="calendar_today" class="tw-mr-2" />
              {{ formattedDate }}
            </div>
            <div>
              <component
                :is="titleTag"
                class="tw-mb-1 tw-text-mb-title-4 lg:tw-text-dt-title-5 tw-line-clamp-2"
                :class="{
                  'tw-min-h-[2lh]': !horizontal,
                  'lg:tw-h-auto': horizontal,
                }"
              >
                {{ title }}
              </component>
              <div
                class="tw-text-mb-body-small lg:tw-text-dt-body-small tw-text-secondary tw-mb-1 tw-truncate"
              >
                {{ categoryTitle }}
              </div>
              <p
                class="tw-text-mb-body-small lg:tw-text-dt-body-small tw-text-dark-gray tw-break-words tw-line-clamp-2"
              >
                {{ description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    image: ImageMeta;
    publishedAt: string;
    title: string;
    category: ArticleCategory;
    description?: string;
    path: string;
    horizontal?: boolean;
    titleTag?: string;
    recommended?: boolean;
  }>(),
  {
    description: '',
    horizontal: false,
    titleTag: 'h3',
    recommended: false,
  },
);

const { $shortDateFormat } = useNuxtApp();
const { currentLocaleCode } = useLanguage();
const categoryTitle = computed(() =>
  resolveLocalizedValue(props.category?.title, currentLocaleCode.value),
);
const formattedDate = ref('-');
onMounted(() => {
  formattedDate.value = props.publishedAt
    ? ($shortDateFormat(props.publishedAt) as string)
    : '-';
});
</script>
